var map = {
	"./Default/sP.png": "4314",
	"./Demon/sOni1.png": "5c50",
	"./Demon/sOni2.png": "eeb2",
	"./Demon/sOni3.png": "ffa8",
	"./Demon/sOniBoss1.png": "786a",
	"./Misc/sCat.png": "5c93",
	"./Misc/sCharon.png": "0545",
	"./Misc/sDog1.png": "9b31",
	"./Skeleton/sSkele1.png": "d394",
	"./Skeleton/sSkele2.png": "2ad9",
	"./Skeleton/sSkele3.png": "9308",
	"./Skeleton/sSkele5.png": "6f42",
	"./Skeleton/sSkeleBoss1.png": "ceed",
	"./Skeleton/sSkeleBoss2.png": "9e50",
	"./Vampire/sVamp1.png": "d852",
	"./Vampire/sVamp2.png": "eec5",
	"./Vampire/sVamp3.png": "52ec",
	"./Vampire/sVamp4.png": "c4c5",
	"./Vampire/sVampBoss11.png": "c349",
	"./Vampire/sVampBoss12.png": "2f0b",
	"./Vampire/sVampBoss2.png": "74f0",
	"./Zombie/sZomb1.png": "94f0",
	"./Zombie/sZomb2.png": "7a51",
	"./Zombie/sZomb3.png": "3b45",
	"./Zombie/sZomb4.png": "cc9a",
	"./Zombie/sZombBoss1.png": "9a5f",
	"./Zombie/sZombBoss2.png": "8b8d",
	"./Zombie/sZombCameraHead.png": "c27a",
	"./sCat.png": "e916",
	"./sCharon.png": "3727",
	"./sDog1.png": "8a8d",
	"./sOni1.png": "8e8c",
	"./sOni2.png": "b41b",
	"./sOni3.png": "3cec",
	"./sOniBoss1.png": "00c5",
	"./sP.png": "3067",
	"./sSkele1.png": "6aa8",
	"./sSkele2.png": "686c",
	"./sSkele3.png": "5338",
	"./sSkele5.png": "0b96",
	"./sSkeleBoss1.png": "2696",
	"./sSkeleBoss2.png": "f6c0",
	"./sVamp1.png": "bc4e",
	"./sVamp2.png": "5c89",
	"./sVamp3.png": "aeac",
	"./sVamp4.png": "eb0c",
	"./sVampBoss11.png": "32e4",
	"./sVampBoss12.png": "d009",
	"./sVampBoss2.png": "a42b",
	"./sZomb1.png": "304e",
	"./sZomb2.png": "bc64",
	"./sZomb3.png": "50a6",
	"./sZomb4.png": "7af3",
	"./sZombBoss1.png": "fd9c",
	"./sZombBoss2.png": "8b04",
	"./sZombCameraHead.png": "70ba"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "f859";